import { Outlet } from "react-router-dom"
import { useUser } from "reactfire";
import Header from "./header";
import { Footer } from "./footer";

const RootLayout = () => {
    const user = useUser();
    return (
        <>
            <Header />
            {user.data ? (
                <div className=" mx-16 lg">
                    <div className="m-4 mt-8">
                        <Outlet context={user?.data?.uid} />
                    </div>
                </div>
            ) : (
                <div className="mx-16 xl">
                    <div className="m-4 mt-8">
                        <Outlet />
                    </div>
                </div>
            )}
            <Footer />
        </>

    );
}

export default RootLayout;